import { Route, Routes } from 'react-router-dom'
import Layout from './components/Layout.jsx'
import ResultsPage from './components/ResultsPage.jsx'
import AllRunsPage from './components/AllRunsPage.jsx'
import ComparePage from './components/ComparePage.jsx'
import TopTenPage from './components/TopTenPage.jsx'
import AdminLayout from './components/AdminLayout.jsx'
import AdminLoginPage from './components/AdminLoginPage.jsx'
import AdminDashboard from './components/AdminDashboard.jsx'
import CommentatorPage from './components/CommentatorPage.jsx'
import { SelectionProvider } from './selection.jsx'
import { AdminAuthProvider, useAdminAuth } from './adminAuth.jsx'

function AdminRoute() {
  const { isAuthed } = useAdminAuth()
  return isAuthed ? <AdminDashboard /> : <AdminLoginPage />
}

export default function App() {
  return (
    <SelectionProvider>
      <AdminAuthProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<ResultsPage />} />
            <Route path="all-runs" element={<AllRunsPage />} />
            <Route path="compare" element={<ComparePage />} />
            <Route path="topten" element={<TopTenPage />} />
          </Route>
          <Route element={<AdminLayout />}>
            <Route path="admin" element={<AdminRoute />} />
          </Route>
          {/* Bare kiosk screen, no nav/tab bar - direct-URL-only, not in TABS. */}
          <Route path="commentator" element={<CommentatorPage />} />
        </Routes>
      </AdminAuthProvider>
    </SelectionProvider>
  )
}
